<!-- eslint-disable vue/no-template-shadow -->
<template>
  <div v-if="!isLoading">
    <v-form class="multi-col-validation my-5 mx-5">
      <v-row>
        <v-col
          cols="12"
          md="3"
        >
          <v-select
            v-model="model.proveedor_id"
            :items="proveedores"
            :label="$t('lbl.proveedor')"
            outlined
            dense
            hide-details
            item-text="name_comercial"
            item-value="id"
          >
            <template v-slot:no-data>
              <v-list-item>
                <v-list-item-title>
                  {{ $t('lbl.proveedor') }}
                </v-list-item-title>
              </v-list-item>
            </template>
          </v-select>
        </v-col>

        <v-col
          cols="12"
          md="3"
        >
          <v-autocomplete
            v-model="model.destino"
            :items="itemsDestinos"
            :search-input.sync="searchDestinos"
            :label="$t('lbl.destino')"
            outlined
            dense
            item-text="name"
            item-value="name"
            single-line
            class="pr-2"
          >
            <template v-slot:no-data>
              <v-list-item>
                <v-list-item-title>
                  {{ noResultDestinos ? $t('lbl.noResultSearchFlight') : $t('lbl.destino') }}
                </v-list-item-title>
              </v-list-item>
            </template>
            <template v-slot:item="{ item }">
              <v-icon left>
                {{ item.icon }}
              </v-icon>
              <v-list-item-content>
                <v-list-item-title>{{ item.name }}</v-list-item-title>
              </v-list-item-content>
            </template>
            <template v-slot:selection="{ item }">
              {{ item.name }}
            </template>
          </v-autocomplete>
        </v-col>

        <v-col
          cols="12"
          md="3"
        >
          <v-menu
            v-model="menuFrom"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
            max-width="290px"
            min-width="auto"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="computedFromDateFormatted"
                :label="$t('lbl.dateIn')"
                persistent-hint
                readonly
                v-bind="attrs"
                outlined
                dense
                style="border-radius: 5px 0px 0px 5px"
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="model.dateIn"
              no-title
              :min="minDate.toISOString().substr(0, 10)"
              locale="es"
              :show-current="false"
              @input="
                menuFrom = false
                activeToDate()
              "
            ></v-date-picker>
          </v-menu>
        </v-col>
        <v-col
          cols="12"
          md="3"
        >
          <v-menu
            v-model="menuTo"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
            max-width="290px"
            min-width="auto"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="computedToDateFormatted"
                :disabled="!model.dateIn"
                :label="$t('lbl.dateOut')"
                persistent-hint
                readonly
                v-bind="attrs"
                outlined
                dense
                style="border-radius: 0px 5px 5px 0px"
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="model.dateOut"
              no-title
              locale="es"
              :show-current="false"
              :min="
                model.dateIn
                  ? $moment(model.dateIn)
                    .add(1, 'day')
                    .toDate()
                    .toISOString()
                    .substr(0, 10)
                  : ''
              "
              @input="menuTo = false"
            ></v-date-picker>
          </v-menu>
        </v-col>

        <v-col
          cols="12"
          md="3"
        >
          <v-select
            v-model="model.operador_id"
            :items="operadores"
            :label="$t('menu.operador')"
            outlined
            dense
            hide-details
            item-text="name"
            item-value="id"
          >
            <template v-slot:no-data>
              <v-list-item>
                <v-list-item-title>
                  {{ $t('menu.operador') }}
                </v-list-item-title>
              </v-list-item>
            </template>
          </v-select>
          <!--<v-autocomplete
            v-model="model.operador_id"
            :items="itemsOperador"
            :search-input.sync="searchOperador"
            hide-details
            hide-selected
            :label="$t('menu.operador')"
            outlined
            dense
            item-text="name"
            item-value="id"
          >
            <template v-slot:no-data>
              <v-list-item>
                <v-list-item-title>
                  {{ $t('lbl.operador') }}
                </v-list-item-title>
              </v-list-item>
            </template>
            <template v-slot:selection="{ item }">
              <span v-text="item.name"></span>
            </template>
            <template v-slot:item="{ item }">
              <v-list-item-content>
                <v-list-item-title>{{ item.name }}</v-list-item-title>
              </v-list-item-content>
            </template>
          </v-autocomplete>-->
        </v-col>
        <v-col
          cols="12"
          md="9"
        >
          <v-select
            v-model="model.hotels"
            :items="hotelsFree"
            :label="$t('menu.hotels')"
            outlined
            dense
            hide-details
            item-text="name"
            item-value="id"
            multiple
          >
            <template v-slot:no-data>
              <v-list-item>
                <v-list-item-title>
                  {{ $t('menu.hotels') }}
                </v-list-item-title>
              </v-list-item>
            </template>
          </v-select>
        </v-col>
      </v-row>
    </v-form>

    <v-divider class="mb-4"></v-divider>
    <v-row>
      <v-col
        cols="12"
        md="1"
      >
        <v-btn
          v-if="
            (model.proveedor_id && model.proveedor_id !== 0) ||
              (model.destino && model.destino !== 'Todos') ||
              model.dateIn ||
              model.dateOut ||
              (model.operador_id && model.operador_id !== 0) ||
              model.hotels.length > 0
          "
          class="mx-2"
          fab
          outlined
          small
          color="error"
          @click="$emit('clearSearch')"
        >
          <v-icon small>
            {{ icons.mdiEraserVariant }}
          </v-icon>
        </v-btn>
      </v-col>
      <v-col
        cols="12"
        md="9"
        class="text-center"
      >
        <v-btn
          color="primary"
          :loading="loading"
          @click="searchItems"
        >
          <v-icon class="mr-4">
            {{ icons.mdiMagnify }}
          </v-icon>
          {{ $t('btn.search') }}
        </v-btn>
      </v-col>
      <v-col
        cols="12"
        md="2"
      >
        <span v-if="itemsTarifarios.length > 0">
          {{ itemsTarifarios.length }} {{ $t('lbl.de') }} {{ hotels.length }} {{ $t('menu.hotels').toLowerCase() }}
        </span>
      </v-col>
    </v-row>
    <v-divider class="mb-4 mt-4"></v-divider>

    <HotelsList
      :user="user"
      :model="model"
      :proveedores="proveedores"
      :operadores="operadores"
      :hotels="hotels"
    />
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'

import {
  mdiMagnify,
  mdiDeleteOutline,
  mdiSquareEditOutline,
  mdiPlus,
  mdiArrowLeft,
  mdiUpdate,
  mdiEyePlus,
  mdiEyeOutline,
  mdiEyeOffOutline,
  mdiFormatListText,
  mdiEraserVariant,
  mdiArrowUp,
  mdiArrowDown,
  mdiMenuDown,
  mdiMenuRight,
  mdiEyeCheck,
} from '@mdi/js'

import HotelsList from './tablas/HotelsList.vue'

export default {
  components: {
    HotelsList,
  },
  props: {
    // eslint-disable-next-line vue/require-default-prop
    proveedores: {
      type: Array,
    },
    // eslint-disable-next-line vue/require-default-prop
    operadores: {
      type: Array,
    },
    // eslint-disable-next-line vue/require-default-prop
    hotels: {
      type: Array,
    },
    // eslint-disable-next-line vue/require-default-prop
    model: {
      type: Object,
    },
    // eslint-disable-next-line vue/require-default-prop
    user: {
      type: Object,
    },
  },

  data() {
    return {
      isLoading: true,
      rutaPublic: process.env.VUE_APP_API_URL_PLUBLIC,
      search: '',
      items: [],
      pagination: {
        current: 1,
        total: 0,
      },
      totalItems: 0,
      totalF: 0,

      showRowProduct: false,
      showRowProveedor: false,
      showRowContrate: false,
      showRowHotel: false,
      showRowRoom: false,
      showRowTemporada: false,
      showRowDate: false,

      // itemsPerPage: 10,
      icons: {
        mdiMagnify,
        mdiDeleteOutline,
        mdiSquareEditOutline,
        mdiPlus,
        mdiArrowLeft,
        mdiUpdate,
        mdiEyePlus,
        mdiEyeOutline,
        mdiEyeOffOutline,
        mdiFormatListText,
        mdiEraserVariant,
        mdiArrowUp,
        mdiArrowDown,
        mdiMenuDown,
        mdiMenuRight,
        mdiEyeCheck,
      },
      isDialogVisible: false,
      itemsOrigen: [],
      searchOrigen: null,
      itemsDestino: [],
      searchDestino: null,
      loading: false,

      showRow: false,
      indexRow: -1,

      itemsDestinos: [],
      searchDestinos: null,
      noResultDestinos: false,
      itemsOperador: [],
      searchOperador: null,

      minDate: new Date(),
      menuFrom: false,
      menuTo: false,
      permisos: sessionStorage.getItem('permisos_auth'),
      itemsList: [],
    }
  },
  computed: {
    ...mapState({
      itemsTarifarios: state => state.app.itemsTarifarios,
    }),
    computedFromDateFormatted() {
      return this.model.dateIn ? this.$moment(this.model.dateIn).format('D-MMM-YY') : ''
    },
    computedToDateFormatted() {
      return this.model.dateOut ? this.$moment(this.model.dateOut).format('D-MMM-YY') : ''
    },
    hotelsFree() {
      let filterHotels = this.hotels
      if (this.model.operador_id && this.model.operador_id !== 0) {
        const filterResult = filterHotels.filter(e => e.operador_id === this.model.operador_id)
        filterHotels = filterResult
      }
      if (this.model.destino && this.model.destino !== 'Todos') {
        const filterResult = filterHotels.filter(
          e => e.country === this.model.destino || e.city === this.model.destino || e.state === this.model.destino,
        )
        filterHotels = filterResult
      }

      return filterHotels
    },
  },
  watch: {
    searchDestinos(val) {
      if (val.length > 2) {
        // eslint-disable-next-line no-unused-expressions
        val && this.filterDestinos(val.toLowerCase())
      } else {
        this.noResultDestinos = false
      }
    },
    searchOperador(val) {
      if (val !== null && val.length > 0) {
        this.filterOperador(val.toLowerCase())
      }
    },
  },
  mounted() {
    setTimeout(() => {
      this.isLoading = false
    }, 100)
  },
  created() {
    if (this.model.destino) {
      this.itemsDestinos.push({
        id: 0,
        name: 'Todos',
      })
    }
  },
  methods: {
    ...mapMutations(['updateMarkupsList', 'deleteMarkupsList', 'updateItemsTarifarios']),
    showItemProduct() {
      this.showRowProduct = !this.showRowProduct
    },
    showItemProveedor() {
      this.showRowProveedor = !this.showRowProveedor
    },
    filterDestinos(v) {
      this.itemsDestinos = []
      // eslint-disable-next-line no-empty
      if (v !== '') {
        // DESTINOS
        this.axios
          .post(
            'destinos-hotels-filter-contrate',
            { search: v },
            {
              headers: {
                Authorization: `Bearer ${sessionStorage.getItem('sanctum_auth')}`,
              },
            },
          )
          .then(res => {
            const result = res.data.data.data
            this.itemsDestinos = []
            this.itemsDestinos.push({
              id: 0,
              name: 'Todos',
            })

            result.forEach(element => {
              // eslint-disable-next-line no-nested-ternary
              this.itemsDestinos.push({
                id: element.id,
                name: element.destino,
              })
            })
          })

        setTimeout(() => {
          if (this.itemsDestinos.length === 0) {
            this.noResultDestinos = true
          }
        }, 500)
      }
    },
    filterOperador(v) {
      this.itemsOperador = []
      if (v === '') {
        this.itemsOperador = []
      } else {
        this.itemsOperador = this.operadores.filter(e => e.name.toLowerCase())
      }
    },

    activeToDate() {
      setTimeout(() => {
        this.menuTo = true
        this.model.dateOut = this.$moment(this.model.dateIn)
          .add('days', 1)
          .format('YYYY-MM-DD')
      }, 100)
    },

    showItem(index) {
      if (this.indexRow === index) {
        this.showRow = !this.showRow
      } else if (!this.showRow) {
        this.showRow = !this.showRow
      }
      this.indexRow = index
    },

    searchItems() {
      if (this.model.dateIn && this.model.dateOut) {
        this.loading = true
        this.updateItemsTarifarios([])
        this.axios
          .post('tarifarios/hotels', this.model, {
            headers: {
              Authorization: `Bearer ${sessionStorage.getItem('sanctum_auth')}`,
            },
          })
          .then(res => {
            // eslint-disable-next-line no-empty
            if (res.data.success === false) {
            } else {
              this.updateItemsTarifarios(res.data.data.items)
            }
          })
          .finally(() => {
            this.loading = false
          })
      } else {
        this.$toast.error(this.$t('msg.datasRequiere'))
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.table-kitchen-sink ::v-deep {
  .v-data-table-header {
    white-space: nowrap;
  }
}
</style>
